module.exports = __webpack_public_path__ + "static/media/settings.f3463e46.png";